import React from "react";
import { Routes, Route, Navigate } from "react-router-dom";

// Layout
import Header from "./components/Header";

// Static pages
import Home from "./pages/Home";
import About from "./pages/About";
import Contact from "./pages/Contact";
import Library from "./pages/Library";

// Docs
import SoftapiDocs from "./pages/docs/SoftapiDocs";
import SoftauthDocs from "./pages/docs/SoftauthDocs";
import SoftautoDocs from "./pages/docs/SoftautoDocs";
import SoftdataDocs from "./pages/docs/SoftdataDocs";
import SoftgraphDocs from "./pages/docs/SoftgraphDocs";
import SofttenantDocs from "./pages/docs/SofttenantDocs";

// Examples
import SoftapiExamples from "./pages/examples/SoftapiExample";
import SoftauthExamples from "./pages/examples/SoftauthExample";
import SoftautoExamples from "./pages/examples/SoftautoExample";
import SoftdataExamples from "./pages/examples/SoftdataExample";
import SoftgraphExamples from "./pages/examples/SoftgraphExample";
import SofttenantExamples from "./pages/examples/SofttenantExample";
import Playground from "./pages/examples/Playground";

export default function App() {
  return (
    <>
      <Header />
      <Routes>
        {/* Main */}
        <Route path="/" element={<Home />} />
        <Route path="/about" element={<About />} />
        <Route path="/library" element={<Library />} />

        {/* Docs */}
        <Route path="/docs/softapi" element={<SoftapiDocs />} />
        <Route path="/docs/softauth" element={<SoftauthDocs />} />
        <Route path="/docs/softauto" element={<SoftautoDocs />} />
        <Route path="/docs/softdata" element={<SoftdataDocs />} />
        <Route path="/docs/softgraph" element={<SoftgraphDocs />} />
        <Route path="/docs/softtenant" element={<SofttenantDocs />} />

        {/* Examples */}
        <Route path="/examples/softapi" element={<SoftapiExamples />} />
        <Route path="/examples/softauth" element={<SoftauthExamples />} />
        <Route path="/examples/softauto" element={<SoftautoExamples />} />
        <Route path="/examples/softdata" element={<SoftdataExamples />} />
        <Route path="/examples/softgraph" element={<SoftgraphExamples />} />
        <Route path="/examples/softtenant" element={<SofttenantExamples />} />

        {/* Contact */}
        <Route path="/contact" element={<Contact />} />

        <Route path="/examples/playground" element={<Playground />} />


        {/* Fallback */}
        <Route path="*" element={<Navigate to="/" replace />} />
      </Routes>

      <footer className="container" style={{ padding: "32px 24px 60px" }}>
        <hr
          style={{
            border: "none",
            borderTop: "1px solid rgba(0,0,0,.08)",
            margin: "0 0 16px",
          }}
        />
        <small className="sidebar">© {new Date().getFullYear()} Soft Tech Talks</small>
      </footer>
    </>
  );
}
